import { computed, ref, shallowReadonly } from '@vue/composition-api';
import { Message } from '../dataType';
import Vue, { AsyncComponent, Component } from 'vue';
const Drawer = () => import('../components/Drawer.vue');

export const showRobotChat = ref(false);
let instance: Vue| undefined;

type AsideComponent = Component | AsyncComponent;
// 侧推内容组件
const asideComponent = ref<AsideComponent>();
const isShowAside = computed<boolean>(() => !!asideComponent.value);

export const useRender = () => {
  const openRobotChat = (): void => {
    // if (!instance) {
    //   const { i18n } = useConfig();
    //   const div = document.createElement('div');
    //   document.body.appendChild(div);
    //   instance = new Vue({
    //     i18n,
    //     data: () => {
    //       return {
    //         visible: false
    //       };
    //     },
    //     methods: {
    //       show() {
    //         this.visible = true;
    //         showRobotChat.value = true;
    //       },
    //       hide() {
    //         this.visible = false;
    //         showRobotChat.value = false;
    //       }
    //     },
    //     render(h) {
    //       return this.visible ? h(Drawer) : h();
    //     }
    //   });
    //   instance.$mount(div);
    // }
    // (instance as any).show();
    // document.body.classList.add('robot-chat-open');
  };

  const closeRobotChat = (destroy: boolean): void => {
    document.body.classList.remove('robot-chat-open');
    if (!instance) {
      return;
    }
    (instance as any).hide();
    closeAside();
    if (destroy) {
      const { $el } = instance;
      instance.$destroy();
      $el.remove();
      instance = void 0;
    }
  };

  const openAside = (component: AsideComponent, message?: Message<any>) => {
    asideComponent.value = {
      render(h) {
        return h(component, {
          props: {
            message
          }
        });
      }
    };
  };

  const closeAside = () => {
    asideComponent.value = void 0;
  };

  return {
    openRobotChat,
    closeRobotChat,
    isRender: shallowReadonly(showRobotChat),
    openAside,
    closeAside,
    asideComponent: shallowReadonly(asideComponent),
    isShowAside: shallowReadonly(isShowAside)
  };
};
